import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { ArrowLeftCircle, BadgeCheck } from "lucide-react";
import {
  EXERCICE_API_ROUTE,
  NIVEAU_API_ROUTE,
  TECHNOLOGY_API_ROUTE,
  CHALLENGE_EXO_API_ROUTE
} from "../../routes/api/api_routes";


const PratiqueNiveauPage = () => {
  const { languageId } = useParams();
  const navigate = useNavigate();
  const [languageName, setLanguageName] = useState("");
  const [levels, setLevels] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [userChallenges, setUserChallenges] = useState([]);
  const [showChallenges, setShowChallenges] = useState(false);

  const token = localStorage.getItem("access");

  useEffect(() => {
    const fetchData = async () => {
      try {
        const [exoRes, niveauRes, techRes] = await Promise.all([
          fetch(EXERCICE_API_ROUTE, {
            headers: { Authorization: `Bearer ${token}` },
          }),
          fetch(NIVEAU_API_ROUTE, {
            headers: { Authorization: `Bearer ${token}` },
          }),
          fetch(`${TECHNOLOGY_API_ROUTE}${languageId}`, {
            headers: { Authorization: `Bearer ${token}` },
          }),
        ]);

        const exosData = await exoRes.json();
        const niveauxData = await niveauRes.json();
        const techData = await techRes.json();

        setLanguageName(techData.name || "Langage");

        const filteredExos = exosData.data.filter(
          (exo) => exo.technology === parseInt(languageId)
        );

        const uniqueNiveauIds = [
          ...new Set(filteredExos.map((exo) => exo.niveau)),
        ];

        const levelInfos = uniqueNiveauIds.map((nivId) => {
          const niveau = niveauxData.data.find((n) => n.id === nivId);
          return {
            id: niveau.id,
            label: niveau.name,
            stars:
              niveau.name.toLowerCase() === "débutant"
                ? 1
                : niveau.name.toLowerCase() === "intermédiaire"
                ? 2
                : 3,
            color:
              niveau.name.toLowerCase() === "débutant"
                ? "bg-yellow-400"
                : niveau.name.toLowerCase() === "intermédiaire"
                ? "bg-blue-400"
                : "bg-green-400",
          };
        });

        setLevels(levelInfos);
      } catch (err) {
        console.error("Erreur lors du chargement des niveaux", err);
      } finally {
        setIsLoading(false);
      }
    };

    fetchData();
  }, [languageId, token]);

  const handleSelectLevel = async (levelId) => {
  const techId = parseInt(languageId);
  const user = JSON.parse(localStorage.getItem("currentUser")); // Assure-toi que "user" est bien dans le localStorage

  if (!user || !user.id) {
    alert("Utilisateur non authentifié");
    return;
  }

  const payload = {
    technologie: techId,
    niveau: levelId,
    user: user.id,
  };

  try {
    const res = await fetch(CHALLENGE_EXO_API_ROUTE, {
      method: "POST",
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
      body: JSON.stringify(payload),
    });

    const data = await res.json();

    if (res.ok && data.id) {
      // navigate(`/pratique/${languageId}/${levelId}/${data.id}`, {
      //   state: { techId },
      // });
      navigate(`/pratique/${languageId}/${levelId}/${data.id}`, {
        state: {
          techId,
          mode: "pratique", // ✅ ici
        },
      });
    } else {
      console.error("Erreur lors de la création du challenge profile", data);
      alert("Erreur lors de la création du challenge profile.");
    }
    } catch (err) {
      console.error("Erreur réseau :", err);
      alert("Erreur réseau lors de la création du challenge profile.");
    }
  };

  const handleShowChallenges = async () => {
  const user = JSON.parse(localStorage.getItem("currentUser"));

    if (!user || !user.id) {
      alert("Utilisateur non connecté.");
      return;
    }

    try {
      const res = await fetch(
        `${CHALLENGE_EXO_API_ROUTE}user/${user.id}/`,
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      );

      const data = await res.json();
      if (res.ok) {
        setUserChallenges(data.data || []);
        setShowChallenges(true);
      } else {
        console.error("Erreur de récupération des challenges:", data);
      }
    } catch (err) {
      console.error("Erreur réseau lors de la récupération des challenges", err);
    }
  };

  if (isLoading) {
    return (
      <div className="text-center mt-10 text-blue-500">Chargement...</div>
    );
  }

  const Modal = ({ onClose, children }) => {
    return (
      <div className="fixed inset-0 z-50 bg-black bg-opacity-50 flex items-center justify-center px-4">
        <div className="bg-white rounded-lg max-w-3xl w-full max-h-[80vh] overflow-y-auto shadow-lg p-6 relative">
          <button
            onClick={onClose}
            className="absolute top-2 right-2 text-gray-500 hover:text-red-600 text-2xl"
          >
            &times;
          </button>
          {children}
        </div>
      </div>
    );
  };


  return (
    <div className="bg-white min-h-screen">

      <div className="relative flex flex-col items-center px-4 py-10 sm:py-14">
        <div className="absolute top-2 left-4 right-4 sm:top-6 sm:left-6 sm:right-6 flex justify-between items-center z-10">
        {/* Bouton retour */}
        <button
          onClick={() => navigate(-1)}
          className="bg-green-600 text-white hover:bg-green-900 transition rounded-full p-1"
        >
          <ArrowLeftCircle className="w-6 h-6 sm:w-8 sm:h-8" />
        </button>


        {/* Bouton voir réalisations */}
        <button
          onClick={handleShowChallenges}
          className="bg-black text-white py-2 px-4 rounded-full hover:bg-green-600 transition text-xs sm:text-base"
        >
          Voir mes réalisations
        </button>
      </div>

        <h1 className="text-3xl font-bold mb-2 text-center">{languageName}</h1>
        <p className="text-gray-700 text-lg mb-8 text-center">
          Choisissez un niveau pour commencer à pratiquer.
        </p>

        <div className="grid grid-cols-2 lg:grid-cols-3 gap-8 w-full max-w-6xl justify-items-center">
          {levels.map((level) => (
            <div
              key={level.id}
              className="bg-gradient-to-br from-gray-100 to-gray-200 rounded-xl shadow p-6 flex flex-col items-center justify-between w-full max-w-sm min-h-max sm:min-h-[300px]"
            >
              <h2 className="text-sm sm:text-xl font-bold text-center mb-4">
                {level.label}
              </h2>

              <div
                className={`w-10 h-10 sm:w-24 sm:h-24 rounded-full flex items-center justify-center ${level.color} mb-4`}
              >
                <BadgeCheck className="text-white w-10 h-10" />
              </div>

              <button
                onClick={() => handleSelectLevel(level.id)}
                className="mt-auto border border-black text-black font-semibold py-1 px-2 sm:py-2 sm:px-6 rounded-full hover:bg-green-500 hover:text-white transition"
              >
                Commencer
              </button>

              <div className="mt-4 hidden sm:flex gap-1">
                {Array(level.stars)
                  .fill()
                  .map((_, i) => (
                    <span key={i} className="text-yellow-500 text-xl">
                      ★
                    </span>
                  ))}
              </div>
            </div>
          ))}
        </div>

      </div>
      {showChallenges && (
        <Modal onClose={() => setShowChallenges(false)}>
          <h2 className="text-2xl font-bold mb-4 text-center">Mes challenges réalisés</h2>
          
          {userChallenges.length === 0 ? (
            <p className="text-gray-600 text-center">Aucun challenge trouvé.</p>
          ) : (
            <ul className="space-y-4">
              {userChallenges.map((challenge) => (
                <li
                  key={challenge.id}
                  className="border p-4 rounded-lg shadow-sm flex justify-between items-center"
                >
                  <div>
                    <p className="font-semibold">Challenge ID: {challenge.id}</p>
                    <p>Score: {challenge.total_score}</p>
                    <p>
                      Terminé:{" "}
                      <span className={challenge.completed ? "text-green-600" : "text-red-500"}>
                        {challenge.completed ? "Oui" : "Non"}
                      </span>
                    </p>
                  </div>
                </li>
              ))}
            </ul>
          )}
        </Modal>
      )}
    </div>
  );
};

export default PratiqueNiveauPage;
